import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  LanguageCode,
  localizationSupportIndex,
} from "../features/localized/localizedApi";
import { setLocalizationIndexes } from "../features/localized/localizedSlice";
import { useAppDispatch } from "./../app/hooks";
import useMessage from "./useMessage";

export const useLocalizationSupportIndex = (enabled = true) => {
  const [isCompleted, setIsCompleted] = useState(false);
  const [error, setError] = useState(false);

  const { t, i18n } = useTranslation();
  const { sendMessage } = useMessage();
  const dispatch = useAppDispatch();

  let UILanguage = i18n.language.slice(0, 2);

  useEffect(() => {
    if (!enabled || !UILanguage) return;
    localizationSupportIndex(UILanguage as LanguageCode)
      .then((res) => {
        dispatch(setLocalizationIndexes(res));
        setIsCompleted(true);
      })
      .catch((err) => {
        sendMessage(t(err.message), "error");
        setIsCompleted(true);
        setError(true);
      });
    // eslint-disable-next-line
  }, [UILanguage, dispatch, enabled]);

  return { isCompleted, error };
};
